var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-danger"},[_vm._v(" "+_vm._s(10 > parseInt(_vm.time / 60) ? '0': undefined)+_vm._s(parseInt(_vm.time / 60))+":"+_vm._s(10 > _vm.time % 60 ? '0': undefined)+_vm._s(_vm.time % 60)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }